import type { Theme } from '@dispatch/web/theme';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const DarkBox = styled(Box)(({ theme }: { theme: Theme }) => ({
  backgroundColor: theme.palette.dark.main,
}));
